<div class="offer-template-container">
  <tyt-offers-wizard-host></tyt-offers-wizard-host>

  <div class="banner-section">
    <div class="title">{{attentionBanner}}</div>
    <div class="subtitle"
      [innerHTML]="offerSet.membership_value_prop_subtitle | markdownToHtml | trustHtml"
    ></div>
    <video #video *ngIf="hasFeaturedMedia" id="HeroVideoPlayer" controls></video>
    <div class="description" [innerHTML]="sanitizedDescription"></div>
  </div>

</div>
